import State from "./State";
class EOLState extends State {
  accept = () => {
    return null;
  };
  toString = () => "EOL";
}
export default EOLState;
//# sourceMappingURL=EOLState.js.map